import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.black
};
export default anchor;